import React from 'react';
import { useIntl } from 'react-intl';

import Tooltip from '@/components/Base/Tooltip/Tooltip';
import { colorGrey400 } from '@/styleUtils';

import { Note } from './AdvertiserNote.styles';

function AdvertiserNote() {
  const { formatMessage } = useIntl();

  return (
    <Note>
      <Tooltip
        contentLabel={formatMessage({ id: 'advertiserNote' })}
        contentTooltip={formatMessage({ id: 'tooltip.advertiserNote' })}
        topIconStyle="0"
        icon="info"
        textColor={colorGrey400}
      />
    </Note>
  );
}

export default AdvertiserNote;
